<template lang="pug">
  .profile-page-form
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Корпус лагеря
      .profile-section__body
        camp-house-editor-modal(
        v-if="showHouseEditor"
        @close="showHouseEditor = false"
        @add-camp-house="addCampHouse"
        :current-house="currentHouse"
        :camp="campData.id"
        )
        .camp-houses-registry
          .camp-houses-registry__button
            button.button.button_paint-main--transparent(
            @click.prevent="onAddCampHouseButton"
            ) Добавить корпус
          .camp-houses-registry__table
            manager-camp-houses-registry-scroll-fix-table(
            :tab-head="housesTableHead"
            :tab-data="housesTableData"
            @on-edit-camp-house="onEditCampHouse"
            @on-delete-camp-house="onDeleteCampHouse"
            )
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Спальные корпуса
      .profile-section__body
        manager-camp-placement-sleeping-houses(
        :sleeping-houses="fields.sleepingHouses"
        :sleeping-houses-names="sleepingHousesNames"
        :camp-data="campData"
        @add-sleeping-house="addSleepingHouse"
        @update-sleeping-house="updateSleepingHouse"
        @delete-sleeping-house="deleteSleepingHouse"
        )
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Питание
      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Название
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.food.name"
                )
          .form__elem(
            v-for="(item, index) in fields.food.items"
          )
            .form-elem.form-elem_horizontal
              .form-elem__title {{index === 0 ? "Пункты" : ""}}
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.food.items[index]"
                )
          .form__elem
            .form-elem.form-elem_right
              .form-elem__title
              .form-elem__body
                button.button.button_paint-main--light.button_narrow(
                @click.prevent="onAddField('food')"
                )
                  .button__text Добавить пункт
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Зоны гигиенического ухода
      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Название
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.hygiene.name"
                )
          .form__elem(
          v-for="(item, index) in fields.hygiene.items"
          )
            .form-elem.form-elem_horizontal
              .form-elem__title {{index === 0 ? "Пункты" : ""}}
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.hygiene.items[index]"
                )
          .form__elem
            .form-elem.form-elem_right
              .form-elem__title
              .form-elem__body
                button.button.button_paint-main--light.button_narrow(
                @click.prevent="onAddField('hygiene')"
                )
                  .button__text Добавить пункт
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Площадки для творчества
      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Название
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.art.name"
                )
          .form__elem(
          v-for="(item, index) in fields.art.items"
          )
            .form-elem.form-elem_horizontal
              .form-elem__title {{index === 0 ? "Пункты" : ""}}
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.art.items[index]"
                )
          .form__elem
            .form-elem.form-elem_right
              .form-elem__title
              .form-elem__body
                button.button.button_paint-main--light.button_narrow(
                @click.prevent="onAddField('art')"
                )
                  .button__text Добавить пункт
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Площадки для спорта
      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Название
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.sport.name"
                )
          .form__elem(
          v-for="(item, index) in fields.sport.items"
          )
            .form-elem.form-elem_horizontal
              .form-elem__title {{index === 0 ? "Пункты" : ""}}
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.sport.items[index]"
                )
          .form__elem
            .form-elem.form-elem_right
              .form-elem__title
              .form-elem__body
                button.button.button_paint-main--light.button_narrow(
                @click.prevent="onAddField('sport')"
                )
                  .button__text Добавить пункт
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Лечение
        .profile-section-switch
          .profile-section-switch__text Показывать на странице лагеря
          .profile-section-switch__elem
            .form-switch
              label.form-switch__label
                input.form-switch__input(
                type="checkbox"
                v-model="fields.treatment.visible"
                )
                .form-switch__outline
                .form-switch__switch
      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Название
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.treatment.name"
                )
          .form__elem(
          v-for="(item, index) in fields.treatment.items"
          )
            .form-elem.form-elem_horizontal
              .form-elem__title {{index === 0 ? "Пункты" : ""}}
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.treatment.items[index]"
                )
          .form__elem
            .form-elem.form-elem_right
              .form-elem__title
              .form-elem__body
                button.button.button_paint-main--light.button_narrow(
                @click.prevent="onAddField('treatment')"
                )
                  .button__text Добавить пункт
    section.profile-page-form__section.profile-section
      .profile-section__body
        .form
          .form__elem.form__elem_button
            .form-elem(
            v-if="campData"
            )
              .form-elem__body
                router-link.button.button_long(
                :to="{name: 'CurrentCamp', params: {campId: campData.id}}"
                target="_blank"
                )
                  .button__text Просмотр
            .form-elem
              .form-elem__body
                button.button.button_paint-main.button_long(
                @click.prevent="onSaveCamp()"
                )
                  .button__text Сохранить

</template>

<script>

import SimpleSelectForm from "../../../../../components/simpleSelectForm/SimpleSelectForm";
import ManagerCampHousesRegistryScrollFixTable from "./components/ManagerCampHousesRegistryScrollFixTable";
import CampHouseEditorModal from "../../../../../components/modals/CampHouseEditorModal";
import ManagerCampPlacementSleepingHouses from "./components/ManagerCampPlacementSleepingHouses";
export default {
  name: "ManagerCampEditorPlacement",
  components: {
    ManagerCampPlacementSleepingHouses,
    CampHouseEditorModal,
    ManagerCampHousesRegistryScrollFixTable,
    SimpleSelectForm
  },
  props: {
    campData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fields: {
        sleepingHouses: [],
        food: {
          name: "",
          type: "питание",
          items: [""]
        },
        hygiene: {
          name: "",
          type: "гигиена",
          items: [""]
        },
        art: {
          name: "",
          type: "творчество",
          items: [""]
        },
        sport: {
          name: "",
          type: "спорт",
          items: [""]
        },
        treatment: {
          name: "",
          type: "лечение",
          items: [""],
          visible: false
        }
      },
      sleepingHousesNames: [],
      housesTableHead: [
        {
          title: "Наименование"
        },
        {
          title: "Вместимость"
        }
      ],
      housesTableData: [],
      showHouseEditor: false,
      currentHouse: null
    };
  },
  computed: {
    defaultSleepingHousesNames() {
      const defaultName = {
        value: null,
        text: "Корпус не выбран"
      };
      if (this.campData) {
        const arr = this.campData.houses.map(item => {
          return {
            value: item.id,
            text: item.name
          };
        });
        arr.unshift(defaultName);
        return arr;
      }
      return [defaultName];
    }
  },
  methods: {
    setSleepingHousesNames() {
      let arr = this.defaultSleepingHousesNames;
      this.fields.sleepingHouses.forEach(i => {
        if (i.name.value) {
          arr = arr.filter(item => {
            return item.value !== i.name.value;
          });
        }
      });
      this.sleepingHousesNames = arr;
    },
    setSleepingHouses(campData) {
      const houses = campData.placement.filter(item => item.type === "корпус");
      if (houses.length > 0) {
        this.fields.sleepingHouses = houses;
      }
    },

    onAddField(fieldName) {
      this.fields[fieldName].items.push("");
    },
    setField(campData, fieldName, type) {
      const field = campData.placement.filter(item => item.type === type);
      if (field.length > 0) {
        this.fields[fieldName].name = field[0].name;
        this.fields[fieldName].type = field[0].type;
        this.fields[fieldName].items = field[0].extra.split(";");
        if (typeof (field[0].visible) !== "undefined") {
          this.fields[fieldName].visible = field[0].visible;
        }
      }
    },

    onAddCampHouseButton() {
      this.currentHouse = null;
      this.showHouseEditor = true;
    },
    onEditCampHouse(house) {
      this.currentHouse = house;
      this.showHouseEditor = true;
    },
    onDeleteCampHouse(house) {
      this.$emit("on-delete-camp-house", house);
    },
    addCampHouse() {
      this.$emit("on-get-camp-data");
    },
    setDisabledHousesInTable() {
      //todo переписать это во что-то более приличное
      const a = this.housesTableData.map(item => {
        return item.id;
      });
      const b = this.fields.sleepingHouses.map(item => {
        return item.name.value;
      });
      const c = [];
      b.forEach(b => {
        a.forEach(a => {
          if (a === b) {
            c.push(a);
          }
        });
      });
      this.housesTableData = this.housesTableData.map(item => {
        item.disabled = false;
        return item;
      });
      c.forEach(c => {
        this.housesTableData = this.housesTableData.map(item => {
          if (item.id === c) {
            item.disabled = true;
          }
          return item;
        });
      });
    },

    addSleepingHouse(data) {
      this.fields.sleepingHouses.push(data);
      this.setSleepingHousesNames();
      this.setDisabledHousesInTable();
    },
    updateSleepingHouse(data, index) {
      this.fields.sleepingHouses[index] = data;
      this.setSleepingHousesNames();
      this.setDisabledHousesInTable();
    },
    deleteSleepingHouse(index) {
      this.fields.sleepingHouses.splice(index, 1);
    },

    onSaveCamp() {
      const campHouses = this.fields.sleepingHouses.filter(item => {
        if (item.name.value || item.room.length > 0 || item.extra.length > 0) {
          return item;
        }
      });
      if (campHouses.length !== 0) {
        this.fields.sleepingHouses = campHouses;
      }
      const fields = [
        "food",
        "hygiene",
        "art",
        "sport",
        "treatment"
      ];

      fields.forEach(field => {
        const items = this.fields[field].items.filter(item => {
          if (item.length > 0) {
            return item;
          }
        });
        if (items.length === 0) {
          items.push("");
        }
        this.fields[field].items = items;
        let fieldJson;
        if (this.fields[field].name.length > 0 || this.fields[field].items > 0) {
          fieldJson = {
            name: this.fields[field].name,
            type: this.fields[field].type,
            extra: items.join(";")
          };
          if (typeof (this.fields[field].visible) !== "undefined") {
            fieldJson.visible = this.fields[field].visible;
          }
        }
        if (fieldJson) {
          campHouses.push(fieldJson);
        }
      });

      const data = {
        placement: campHouses
      };
      this.$emit("on-save-camp", data);
    },
    buildPage(campData) {
      this.setSleepingHouses(campData);
      this.setSleepingHousesNames(campData);
      this.housesTableData = campData.houses;
      this.setDisabledHousesInTable();
      const fields = [
        {
          name: "food",
          type: "питание"
        },
        {
          name: "hygiene",
          type: "гигиена"
        },
        {
          name: "art",
          type: "творчество"
        },
        {
          name: "sport",
          type: "спорт"
        },
        {
          name: "treatment",
          type: "лечение"
        }
      ];
      fields.forEach(field => {
        this.setField(campData, field.name, field.type);
      });
    }
  },
  mounted() {
    if (this.campData) {
      this.buildPage(this.campData);
    }
  },
  watch: {
    campData(val) {
      this.buildPage(val);
    }
  }
};
</script>
